import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  Switch,
  CardHeader,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import PageHeader from 'src/views/Common/PageHeader';
import { useAlert } from "react-alert";
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import ObjectCompare from 'src/utils/ObjectCompare';
import authService from '../../../utils/permissionAuth';
import { AlertDialogWithoutButton } from 'src/views/Common/AlertDialogWithoutButton';

const screenCode = 'BUDGETCODE';
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

export default function BudgetCodeAddEdit() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("Account Code Creation")
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDisableButton, setIsDisableButton] = useState(false);
  const classes = useStyles();
  const [budgetCode, setBudgetCode] = useState({
    budgetCode: '',
    budgetCodeName: '',
    budgetCodeDescription: '',
    isActive: true,
  });
  const [dialog, setDialog] = useState(false);
  const [initialBudgetCode, setnItialBudgetCode] = useState(budgetCode);
  const { budgetCodeID } = useParams();
  const alert = useAlert();
  let decrypted = 0;

  useEffect(() => {
    decrypted = atob(budgetCodeID.toString());
    if (decrypted != 0) {
      trackPromise(
        getBudgetCodeByID(decrypted)
      )
    }
  }, []);

  useEffect(() => {
    getPermissions();
  }, []);

  async function getBudgetCodeByID(budgetCodeID) {
    let response = await services.GetBudgetCodesByID(budgetCodeID);
    let data = response[0];
    setTitle("Edit Account Code");
    setBudgetCode(data);
    setnItialBudgetCode(data);
    setIsUpdate(true);
    setIsDisableButton(true);
  }
  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITBUDGETCODE');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
  }

  async function saveBudgetCode(values) {
    if (isUpdate == true) {

      let updateModel = {
        budgetCodeID: atob(budgetCodeID.toString()),
        budgetCode: values.budgetCode,
        budgetCodeName: values.budgetCodeName,
        budgetCodeDescription: values.budgetCodeDescription,
        isActive: values.isActive,
      }

      let response = await services.UpdateBudgetCode(updateModel);
      if (response.statusCode == "Success") {
        alert.success(response.message);
        setIsDisableButton(true);
        navigate('/app/BudgetCode/listing');
      }
      else {
        alert.error(response.message);
      }
    } else {
      let response = await services.SaveBudgetCode(values);
      if (response.statusCode == "Success") {
        alert.success(response.message);
        setIsDisableButton(true);
        navigate('/app/BudgetCode/listing');
      }
      else {
        alert.error(response.message);
      }
    }
  }

  const handleClick = () => {
    const isChange = ObjectCompare.isObjectEqual(initialBudgetCode, budgetCode);
    if (isChange) navigate('/app/BudgetCode/listing');
    else setDialog(true);
  }

  async function confirmRequest() {
    navigate('/app/BudgetCode/listing');
  }

  async function cancelRequest() {
    setDialog(false);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              budgetCode: budgetCode.budgetCode,
              budgetCodeName: budgetCode.budgetCodeName,
              budgetCodeDescription: budgetCode.budgetCodeDescription,
              isActive: budgetCode.isActive,
            }}
            validationSchema={
              Yup.object().shape({
                budgetCode: Yup.string().max(255).required('Account  code is required').max(10, 'Account Code must be at most 6 characters').matches(/^\S*$/, 'Account Code cannot contain spaces'),
                budgetCodeName: Yup.string().required('Account Code Name is required').matches(/^\S.*\S$|^\S$/, 'Spaces are not allowed at start or end'),
                budgetCodeDescription: Yup.string()
                .max(255, 'Account  Type Description must be at most 255 characters')
                .matches(/^\S.*\S$|^\S$|^$/, 'Spaces are not allowed at start or end')
                .nullable(),
              })
            }
            onSubmit={saveBudgetCode}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              isSubmitting,
              handleChange,
              touched,
              values,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="budgetCode">
                              Account Code *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.budgetCode && errors.budgetCode)}
                              fullWidth
                              placeholder='Enter Account Code'
                              helperText={touched.budgetCode && errors.budgetCode}
                              name="budgetCode"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => setFieldValue("budgetCode", e.target.value)}
                              value={values.budgetCode}
                              variant="outlined"
                              disabled={isDisableButton}
                              InputProps={{
                                readOnly: isUpdate ? true : false,
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value.slice(0, 10)
                              }}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="budgetCodeName">
                              Account Code Name *
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.budgetCodeName && errors.budgetCodeName)}
                              fullWidth
                              helperText={touched.budgetCodeName && errors.budgetCodeName}
                              name="budgetCodeName"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => setFieldValue("budgetCodeName", e.target.value)}
                              value={values.budgetCodeName}
                              variant="outlined"
                              placeholder='Enter Account Code Name'
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="budgetCodeDescription">
                              Account Code Description
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.budgetCodeDescription && errors.budgetCodeDescription)}
                              fullWidth
                              helperText={touched.budgetCodeDescription && errors.budgetCodeDescription}
                              name="budgetCodeDescription"
                              size='small'
                              onBlur={handleBlur}
                              onChange={(e) => setFieldValue("budgetCodeDescription", e.target.value)}
                              value={values.budgetCodeDescription}
                              variant="outlined"
                              placeholder='Enter Account Code Description'
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="isActive">
                              Active
                            </InputLabel>
                            <Switch
                              checked={values.isActive}
                              onChange={(e) => handleChange(e)}
                              name="isActive"
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          disabled={values.budgetCode === initialBudgetCode.budgetCode && values.budgetCodeName === initialBudgetCode.budgetCodeName && values.budgetCodeDescription === initialBudgetCode.budgetCodeDescription && values.isActive === initialBudgetCode.isActive}
                          type="submit"
                          variant="contained"
                        >
                          {isUpdate == true ? "Update" : "Save"}
                        </Button>
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
                {dialog ?
                  <AlertDialogWithoutButton confirmData={confirmRequest} cancelData={cancelRequest}
                    headerMessage={"Account Code"}
                    discription={"The added Account Code details will not be saved. Are you sure you want to leave?"} />
                  : null}
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  )
};